import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import {
  AddAlarmConditions,
  AddDailyShipStaffTask,
  AddDeckLog,
  AddEngineLogBook,
  AddGarbageLog,
  AddOliRecordLog,
  AddSoundingLogBook,
  AddStaffVoyage,
  AuditTraildaily,
  AuditTrailDeck,
  AuditTrailGarbage,
  AuditTrailList,
  AuditTrailOil,
  AuditTrailSound,
  DeckLogBookList,
  EditDailyShipStaffTask,
  EditDeckLog,
  EditEngineLogBook,
  EditGarbageLog,
  EditOilRecordLog,
  EditStaffVoyage,
  GarbageLogBookList,
  ListDailyShipStaffTask,
  ListenginelogBook,
  ListOilRecordLog,
  SoundLogBookList,
  SoundLogBookViewList,
  StaffDashboard,
  StaffDashboardLayout,
  StaffEditShip,
  VoyageListingStaff,
  AuditTrailstaffVoyage,
  ListOilRecordLogOne,
  AddOliRecordLogPartOne,
  EditOilRecordLogOne,
  AuditTrailOilOne,
  DailyConsumptionList,
  DailyConsumption,
  NotificationList,
  GarbageLogBookListTwo,
  AddGarbageLogTwo,
  EditGarbageLogTwo,
  AuditTrailGarbageTwo,
  AddBallastRecordBook,
  EditBallastRecordBook,
  ListBallastRecordBook,
  AuditTrailBallastRecordBook,
  AddBunkerDetails,
  EditBunkerDetails,
  ListBunkerDetails,
  AuditTrailBunker,
  Addbunkerdelivery,
  AuditTrailBunkerdelivery,
  EditBunkerDelivery,
  ListBunkerDelivery,
  AddFuelChangeover,
  ListFuelChangeover,
  EditBunkerFuelChangeover,
  AuditTrailFuelChangeover,
  ViewOilRecordLogOne,
  ViewOilRecordLog,
  AuditTrailBunkerRecordBook,
  AuditTraildailyConsumtion,
  ViewBallastRecordBook,
  AuditTrailCargoRecordBook,
  AddCargoRecordBook,
  EditCargoRecordBook,
  ListCargoRecordBook,
  ViewCargoRecordBook,
  ViewBunkerDetails,
  AddRestHours,
  EditRestHours,
  ListRestHours,
  ViewRestHours,
  AuditTrailRestHours,
  RestHoursCrewRecordsStaff,
  RecordsRestHours,
  ViolationsStaff,
  RestHoursDashboard,
} from "../staff";
import AddBunkerReport from "../staff/pages/bunker-record/add";
import ListBunkerReport from "../staff/pages/bunker-record/list";
import ViewBunkerReport from "../staff/pages/bunker-record/view";
import ViewBunkerDelivery from "../staff/pages/sulphur-record/bunker-delivery-note/view";
import ViewBunkerFuelChangeover from "../staff/pages/sulphur-record/fuel-changeover/view";
// 🔹 ODS RECORDS
import ListEquipContainingLog from "../staff/pages/ods-records/equip-containing-log/list";
import AddEquipContainingLog from "../staff/pages/ods-records/equip-containing-log/add";
import EditEquipContainingLog from "../staff/pages/ods-records/equip-containing-log/edit";
import ViewEquipContainingLog from "../staff/pages/ods-records/equip-containing-log/view";

import ListSupplyAndDischargeLog from "../staff/pages/ods-records/supply-and-discharge-log/list";
import AddSupplyAndDischargeLog from "../staff/pages/ods-records/supply-and-discharge-log/add";
import EditSupplyAndDischargeLog from "../staff/pages/ods-records/supply-and-discharge-log/edit";
import ViewSupplyAndDischargeLog from "../staff/pages/ods-records/supply-and-discharge-log/view";

import ListRefrigerationEquipLog from "../staff/pages/ods-records/refrigeration-equip-log/list";
import AddRefrigerationEquipLog from "../staff/pages/ods-records/refrigeration-equip-log/add";
import EditRefrigerationEquipLog from "../staff/pages/ods-records/refrigeration-equip-log/edit";
import ViewRefrigerationEquipLog from "../staff/pages/ods-records/refrigeration-equip-log/view";
import WorkOrderReport from "../staff/pages/pms/machinery-register/WorkOrderReport";
import JobRegisterTab from "../staff/pages/pms/machinery-register/JobRegisterTab";
import FunctionHierarchy from "../staff/pages/pms/function-hierarchy";
import AddMachinery from "../staff/pages/pms/machinery-register";
import ListStaff from "../staff/pages/staff/list";
import LogHours from "../staff/pages/rest-hours/LogHours";
import AssignedToMe from "../staff/pages/pms/machinery-register/AssignedToMe";
import AddStaff from "../staff/pages/staff/add";
import AuditTrailStaffCom from "../staff/pages/staff/AuditTrailstaff";
import EditStaff from "../staff/pages/staff/edit";
import TimeDateSettings from "../components/time/TimeDateSettings";

function StaffRoute() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <>
            <Route path="/" element={<StaffDashboardLayout />}>
              <Route path="/" element={<StaffDashboard />} />
              <Route
                path="/add-engine-basic-info/"
                element={<AddEngineLogBook />}
              />
              <Route path="/edit-ship" element={<StaffEditShip />} />
              <Route
                path="/staff-voyage-list"
                element={<VoyageListingStaff />}
              />
              <Route path="/voyage-add" element={<AddStaffVoyage />} />
              <Route path="/voyage-view/:id" element={<EditStaffVoyage />} />
              <Route
                path="/edit-engine-basic-info/:eng_log_basic_id"
                element={<EditEngineLogBook />}
              />
              <Route
                path="/list-engine-basic-info"
                element={<ListenginelogBook />}
              />
              <Route path="/list-deck-log" element={<DeckLogBookList />} />
              <Route path="/add-deck-log" element={<AddDeckLog />} />
              <Route path="/edit-deck-log/:id" element={<EditDeckLog />} />
              <Route path="/list-sound-log" element={<SoundLogBookList />} />
              <Route
                path="/view-sound-log/:soundingLog_id"
                element={<SoundLogBookViewList />}
              />
              <Route path="/add-sound-log" element={<AddSoundingLogBook />} />
              <Route path="/add-alarm" element={<AddAlarmConditions />} />
              <Route
                path="/list-garbage-log"
                element={<GarbageLogBookList />}
              />
              <Route path="/add-garbage-log" element={<AddGarbageLog />} />
              <Route
                path="/edit-garbage-log/:garbage_id"
                element={<EditGarbageLog />}
              />
              <Route
                path="/audit-trail-garbage"
                element={<AuditTrailGarbage />}
              />
              <Route
                path="/list-garbage-log-two"
                element={<GarbageLogBookListTwo />}
              />
              <Route
                path="/add-garbage-log-two"
                element={<AddGarbageLogTwo />}
              />
              <Route
                path="/edit-garbage-log-two/:garbage_id"
                element={<EditGarbageLogTwo />}
              />
              <Route
                path="/audit-trail-garbage-two"
                element={<AuditTrailGarbageTwo />}
              />
              <Route path="/add-oil-record-log" element={<AddOliRecordLog />} />
              <Route
                path="/list-oil-record-log"
                element={<ListOilRecordLog />}
              />
              <Route
                path="/edit-oil-record-log/:oil_record_id"
                element={<EditOilRecordLog />}
              />
              <Route
                path="/view-oil-record-log/:oil_record_id"
                element={<ViewOilRecordLog />}
              />
              <Route
                path="/add-oil-record-log-one"
                element={<AddOliRecordLogPartOne />}
              />
              <Route
                path="/list-oil-record-log-one"
                element={<ListOilRecordLogOne />}
              />
              <Route
                path="/edit-oil-record-log-one/:oil_record_id"
                element={<EditOilRecordLogOne />}
              />
              <Route
                path="/view-oil-record-log-one/:oil_record_id"
                element={<ViewOilRecordLogOne />}
              />
              <Route
                path="/audit-trail-oil-one"
                element={<AuditTrailOilOne />}
              />
              <Route
                path="/list-daily-ship-staff-task"
                element={<ListDailyShipStaffTask />}
              />
              <Route
                path="/add-daily-ship-staff-task"
                element={<AddDailyShipStaffTask />}
              />
              <Route
                path="/edit-daily-ship-staff-task/:id"
                element={<EditDailyShipStaffTask />}
              />
              <Route path="/audit-trail-engine" element={<AuditTrailList />} />
              <Route path="/audit-trail-deck" element={<AuditTrailDeck />} />
              <Route path="/audit-trail-sound" element={<AuditTrailSound />} />
              <Route path="/audit-trail-oil" element={<AuditTrailOil />} />
              <Route path="/audit-trail-daily" element={<AuditTraildaily />} />
              <Route
                path="/audit-trail-staff-voyage"
                element={<AuditTrailstaffVoyage />}
              />
              <Route
                path="/daily-consumption"
                element={<DailyConsumptionList />}
              />
              <Route path="/company-staff-list" element={<ListStaff />} />
              <Route
                path="/add-daily-consumption"
                element={<DailyConsumption />}
              />
              <Route path="/notification" element={<NotificationList />} />
              <Route
                path="/add-ballast-record"
                element={<AddBallastRecordBook />}
              />
              <Route
                path="/edit-ballast-record/:ballast_id"
                element={<EditBallastRecordBook />}
              />
              <Route
                path="/view-ballast-record/:ballast_id"
                element={<ViewBallastRecordBook />}
              />
              <Route
                path="/list-ballast-record"
                element={<ListBallastRecordBook />}
              />
              <Route
                path="/audit-trail-ballast-record"
                element={<AuditTrailBallastRecordBook />}
              />
              <Route path="/add-bunker-record" element={<AddBunkerReport />} />
              <Route
                path="/list-bunker-record"
                element={<ListBunkerReport />}
              />
              <Route
                path="/view-bunker-record/:bunkerLog_id"
                element={<ViewBunkerReport />}
              />
              <Route
                path="/audit-trail-bunker-record"
                element={<AuditTrailBunkerRecordBook />}
              />
              <Route
                path="/add-bunker-details"
                element={<AddBunkerDetails />}
              />
              <Route
                path="/list-bunker-detail"
                element={<ListBunkerDetails />}
              />
              <Route
                path="/edit-bunker-details/:bunker_id"
                element={<EditBunkerDetails />}
              />
              <Route
                path="/view-bunker-details/:bunker_id"
                element={<ViewBunkerDetails />}
              />
              <Route
                path="/audit-trail-bunker-details"
                element={<AuditTrailBunker />}
              />
              <Route
                path="/add-bunker-delivery-note"
                element={<Addbunkerdelivery />}
              />
              <Route
                path="/list-bunker-delivery-note"
                element={<ListBunkerDelivery />}
              />
              <Route
                path="/edit-bunker-delivery-note/:bunkerdelivery_id"
                element={<EditBunkerDelivery />}
              />
              <Route
                path="/view-bunker-delivery-note/:bunkerdelivery_id"
                element={<ViewBunkerDelivery />}
              />
              <Route
                path="/audit-trail-bunker-delivery-note"
                element={<AuditTrailBunkerdelivery />}
              />
              <Route
                path="/add-fuel-changeover"
                element={<AddFuelChangeover />}
              />
              <Route
                path="/list-fuel-changeover"
                element={<ListFuelChangeover />}
              />
              <Route
                path="/edit-fuel-changeover/:fuel_id"
                element={<EditBunkerFuelChangeover />}
              />
              <Route
                path="/view-fuel-changeover/:fuel_id"
                element={<ViewBunkerFuelChangeover />}
              />
              <Route
                path="/audit-trail-fuel-changeover"
                element={<AuditTrailFuelChangeover />}
              />
              <Route
                path="/audit-trail-consumption"
                element={<AuditTraildailyConsumtion />}
              />
              <Route
                path="/add-cargo-record"
                element={<AddCargoRecordBook />}
              />
              <Route
                path="/edit-cargo-record/:cargo_id"
                element={<EditCargoRecordBook />}
              />
              <Route
                path="/list-cargo-record"
                element={<ListCargoRecordBook />}
              />
              <Route
                path="/view-cargo-record/:cargo_id"
                element={<ViewCargoRecordBook />}
              />
              <Route
                path="/audit-trail-cargo-record"
                element={<AuditTrailCargoRecordBook />}
              />

              {/* 🔹 ODS EQUIPMENT */}
              <Route
                path="/equip-containing-log"
                element={<ListEquipContainingLog />}
              />
              <Route
                path="/add-equip-containing-log"
                element={<AddEquipContainingLog />}
              />
              <Route
                path="/edit-equip-containing-log/:id"
                element={<EditEquipContainingLog />}
              />
              <Route
                path="/view-equip-containing-log/:id"
                element={<ViewEquipContainingLog />}
              />

              {/* 🔹 ODS REFRIGERANT */}
              <Route
                path="/supply-and-discharge-log"
                element={<ListSupplyAndDischargeLog />}
              />
              <Route
                path="/add-supply-and-discharge-log"
                element={<AddSupplyAndDischargeLog />}
              />
              <Route
                path="/edit-supply-and-discharge-log/:id"
                element={<EditSupplyAndDischargeLog />}
              />
              <Route
                path="/view-supply-and-discharge-log/:id"
                element={<ViewSupplyAndDischargeLog />}
              />

              {/* 🔹 ODS RECORD */}
              <Route
                path="/refrigeration-equip-log"
                element={<ListRefrigerationEquipLog />}
              />
              <Route
                path="/add-refrigeration-equip-log"
                element={<AddRefrigerationEquipLog />}
              />
              <Route
                path="/edit-refrigeration-equip-log/:id"
                element={<EditRefrigerationEquipLog />}
              />
              <Route
                path="/view-refrigeration-equip-log/:id"
                element={<ViewRefrigerationEquipLog />}
              />

              {/* 🔹 REST HOURS */}
              <Route
                path="/resthours-dashboard"
                element={<RestHoursDashboard />}
              />
              {/* <Route path="/log-hours" element={<ListRestHours/>} /> */}
              <Route path="/log-hours" element={<LogHours />} />
              <Route
                path="/resthours"
                element={<Navigate to="/log-hours" replace />}
              />
              <Route
                path="/rest-hours-crew-record"
                element={<RestHoursCrewRecordsStaff />}
              />
              <Route
                path="/work-rest/crew-records"
                element={<RestHoursCrewRecordsStaff />}
              />
              <Route path="/add-staff" element={<AddStaff />} />
              <Route path="/records" element={<RecordsRestHours />} />
              <Route path="/resthours/records" element={<RecordsRestHours />} />
              <Route path="/add-rest-hours" element={<AddRestHours />} />
              <Route path="/edit-rest-hours/:id" element={<EditRestHours />} />
              <Route path="/view-rest-hours/:id" element={<ViewRestHours />} />
              <Route
                path="/audit-trail-rest-hours"
                element={<AuditTrailRestHours />}
              />
              <Route
                path="/resthours/violations"
                element={<ViolationsStaff />}
              />
              <Route path="/violations" element={<ViolationsStaff />} />

              {/* PMS */}
              <Route path="/assigned-to-me" element={<AssignedToMe />} />
              <Route path="/work-order/:id" element={<WorkOrderReport />} />
              <Route
                path="/function-hierarchy"
                element={<FunctionHierarchy />}
              />
              <Route path="/add-machinery" element={<AddMachinery />} />
              <Route path="/audit-trail" element={<AuditTrailStaffCom />} />
              <Route path="/staff-update/:staff_id/" element={<EditStaff />} />

              {/*
                API module routes. These URLs are returned by staff-modules and
                are used directly by SidebarNavigation. Keep the legacy routes
                above so links used inside the existing screens still work.
              */}
              <Route path="/dashboard" element={<StaffDashboard />} />
              <Route path="/fleet/vessels" element={<StaffEditShip />} />
              <Route path="/fleet/staff" element={<ListStaff />} />
              <Route
                path="/vessel-operations/voyages"
                element={<VoyageListingStaff />}
              />

              <Route
                path="/maintenance"
                element={<Navigate to="/maintenance/dashboard" replace />}
              />
              <Route path="/maintenance/dashboard" element={<StaffDashboard />} />
              <Route
                path="/maintenance/function-hierarchy"
                element={<FunctionHierarchy />}
              />
              <Route
                path="/maintenance/job-register"
                element={<JobRegisterTab />}
              />
              <Route
                path="/maintenance/log"
                element={<JobRegisterTab />}
              />
              <Route
                path="/maintenance/assigned-to-me"
                element={<AssignedToMe />}
              />

              <Route
                path="/rest-hours"
                element={<Navigate to="/rest-hours/dashboard" replace />}
              />
              <Route
                path="/rest-hours/dashboard"
                element={<RestHoursDashboard />}
              />
              <Route path="/rest-hours/log-hours" element={<LogHours />} />
              <Route
                path="/rest-hours/crew-records"
                element={<RestHoursCrewRecordsStaff />}
              />
              <Route
                path="/rest-hours/records"
                element={<RecordsRestHours />}
              />
              <Route
                path="/rest-hours/violations"
                element={<ViolationsStaff />}
              />

              <Route
                path="/ship-records/logbooks/engine"
                element={<ListenginelogBook />}
              />
              <Route
                path="/ship-records/logbooks/deck"
                element={<DeckLogBookList />}
              />
              <Route
                path="/ship-records/logbooks/sounding"
                element={<SoundLogBookList />}
              />
              <Route
                path="/ship-records/record-books/cargo"
                element={<ListCargoRecordBook />}
              />
              <Route
                path="/ship-records/oil-record-book/part-1"
                element={<ListOilRecordLogOne />}
              />
              <Route
                path="/ship-records/oil-record-book/part-2"
                element={<ListOilRecordLog />}
              />
              <Route
                path="/ship-records/garbage-record-book"
                element={
                  <Navigate
                    to="/ship-records/garbage-record-book/part-1"
                    replace
                  />
                }
              />
              <Route
                path="/ship-records/garbage-record-book/part-1"
                element={<GarbageLogBookList />}
              />
              <Route
                path="/ship-records/garbage-record-book/part-2"
                element={<GarbageLogBookListTwo />}
              />
              <Route
                path="/ship-records/record-books/ballast-water"
                element={<ListBallastRecordBook />}
              />
              <Route
                path="/ship-records/record-books/bunker"
                element={<ListBunkerReport />}
              />
              <Route
                path="/ship-records/record-books/ods"
                element={
                  <Navigate
                    to="/ship-records/record-books/ods/equipment-containing"
                    replace
                  />
                }
              />
              <Route
                path="/ship-records/record-books/ods/equipment-containing"
                element={<ListEquipContainingLog />}
              />
              <Route
                path="/ship-records/record-books/ods/supply-discharge"
                element={<ListSupplyAndDischargeLog />}
              />
              <Route
                path="/ship-records/record-books/ods/refrigeration"
                element={<ListRefrigerationEquipLog />}
              />

              <Route
                path="/environment/consumption"
                element={<Navigate to="/environment/consumption/daily" replace />}
              />
              <Route
                path="/environment/consumption/daily"
                element={<DailyConsumptionList />}
              />
              <Route
                path="/environment/compliance/sulphur-record-book"
                element={
                  <Navigate
                    to="/environment/compliance/sulphur-record-book/bd"
                    replace
                  />
                }
              />
              <Route
                path="/environment/compliance/sulphur-record-book/bd"
                element={<ListBunkerDetails />}
              />
              <Route
                path="/environment/compliance/sulphur-record-book/bdn"
                element={<ListBunkerDelivery />}
              />
              <Route
                path="/environment/compliance/sulphur-record-book/fcr"
                element={<ListFuelChangeover />}
              />

              <Route path="/utilities/alarms" element={<AddAlarmConditions />} />
              <Route
                path="/utilities/settings/time-date"
                element={<TimeDateSettings />}
              />
              <Route
                path="/utilities/other-logs/daily-staff-task"
                element={<ListDailyShipStaffTask />}
              />
              <Route
                path="/utilities/other-logs/notifications"
                element={<NotificationList />}
              />
            </Route>
          </>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default StaffRoute;
